import React, { Component } from 'react';
import { Provider } from 'react-redux';
import RenderInBody from 'components/shared/render_in_body';
import AssignModalContainer from './Container';
import assignStore from '../../stores/assignStore';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.store = assignStore(props.state);
  }

  render() {
    return (
      <RenderInBody>
        <Provider store={this.store}>
          <AssignModalContainer
            toggleContainer={this.props.toggleContainer}
            timeZones={this.props.timeZones}
            eventData={this.props.eventData}
            assignAllContent={this.props.assignAllContent}
            currentSessionId={this.props.currentSessionId}
          />
        </Provider>
      </RenderInBody>
    );
  }
}

export default Modal;
